import { LearnPlaybook } from "@/types/learn";

// Playbook content is authored in the collateral pipeline
// (scripts/collateral/build-playbook-*.mjs) and rendered to a fully-branded
// PDF in public/collateral/playbooks/. The registry below is a thin index
// over those artifacts — title, description, category, accent — driving the
// playbook cards in the Learn page.
//
// If you need a new playbook, add a builder under scripts/collateral/, run
// `node scripts/collateral/build-all.mjs`, then add an entry here pointing
// at the resulting PDF.

export type PlaybookTemplate = LearnPlaybook & {
  staticPdfUrl: string;
};

export const PLAYBOOK_REGISTRY: PlaybookTemplate[] = [
  {
    slug: "lead-capture",
    title: "Lead Capture Playbook",
    description:
      "Turn website and social traffic into qualified leads. A five-step setup, an end-to-end example, and a weekly habit that keeps your Genie improving.",
    category: "growth",
    estReadMinutes: 8,
    storagePath: "/collateral/playbooks/lead-capture/index.pdf",
    staticPdfUrl: "/collateral/playbooks/lead-capture/index.pdf",
    thumbnailUrl: null,
    coverAccent: "#4E9CFF",
  },
  {
    slug: "after-hours-support",
    title: "After-Hours Support Playbook",
    description:
      "Cover nights and weekends without burning out your team. Pull the questions, build the knowledge, set the escalation rule, watch the morning roundup.",
    category: "support",
    estReadMinutes: 7,
    storagePath: "/collateral/playbooks/after-hours-support/index.pdf",
    staticPdfUrl: "/collateral/playbooks/after-hours-support/index.pdf",
    thumbnailUrl: null,
    coverAccent: "#FF4DB8",
  },
  {
    slug: "bookings",
    title: "Bookings & Appointments Playbook",
    description:
      "Fill the calendar, qualify the work, and cut no-shows. The setup every service business should run first.",
    category: "operations",
    estReadMinutes: 8,
    storagePath: "/collateral/playbooks/bookings/index.pdf",
    staticPdfUrl: "/collateral/playbooks/bookings/index.pdf",
    thumbnailUrl: null,
    coverAccent: "#FFBB33",
  },
  {
    slug: "knowledge-base",
    title: "Knowledge Base Power-Up Playbook",
    description:
      "The shape of your knowledge base is the ceiling on your Genie. Audit, re-shape, scope, and close the loop weekly.",
    category: "quality",
    estReadMinutes: 9,
    storagePath: "/collateral/playbooks/knowledge-base/index.pdf",
    staticPdfUrl: "/collateral/playbooks/knowledge-base/index.pdf",
    thumbnailUrl: null,
    coverAccent: "#4E9CFF",
  },
  {
    slug: "survey-genie",
    title: "Survey Genie Playbook",
    description:
      "Replace dead static forms with a conversation. Higher completion, richer answers, less corporate.",
    category: "growth",
    estReadMinutes: 7,
    storagePath: "/collateral/playbooks/survey-genie/index.pdf",
    staticPdfUrl: "/collateral/playbooks/survey-genie/index.pdf",
    thumbnailUrl: null,
    coverAccent: "#FF4DB8",
  },
  {
    slug: "brand-voice",
    title: "Brand Voice Playbook",
    description:
      "Make your Genie sound like you, not like generic AI. Pairs with Genie Trust Center in the product.",
    category: "brand",
    estReadMinutes: 7,
    storagePath: "/collateral/playbooks/brand-voice/index.pdf",
    staticPdfUrl: "/collateral/playbooks/brand-voice/index.pdf",
    thumbnailUrl: null,
    coverAccent: "#FFBB33",
  },
];

export function getPlaybookBySlug(slug: string): PlaybookTemplate | null {
  return PLAYBOOK_REGISTRY.find((p) => p.slug === slug) ?? null;
}
